const rotatingBanners = []

export default rotatingBanners
